<template>
    <div>
        <b-button
            variant="primary"
            @click.stop="abrirModal()"
            title="Realiza o upload do modelo (template)"
        >
            <span> <i class="fa fa-upload"></i> Upload Modelo</span>
        </b-button>
        <b-modal v-model="mostrarModal" :hide-footer="true">
            <div slot="modal-title">
                Modelo {{ tipo == 'padrao' ? 'Padrão' : 'Convênio' }} - Upload
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="arquivo == null"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'

export default {
    props: {
        // modelo: {
        //     type: Object,
        //     default: () => ({})
        // },

        tipo: {
            type: String,
            default: () => 'padrao'
        },

        tipoDocumento: {
            type: String
        }
    },

    data() {
        return {
            mostrarModal: false,
            arquivo: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.arquivo = null
            this.mostrarModal = false
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Modelo',
                html: `Confirma o upload do modelo?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let modeloDto = {
                arquivo: this.arquivo
            }
            ConveniosServicos.uploadModelo(
                this.$route.params.convenioId,
                this.tipo,
                modeloDto,
                this.tipoDocumento
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Upload realizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterAtualizacao')
                        this.fecharModal()
                    } else {
                        this.$toast.error(
                            'Erro ao realizar upload do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
